<script lang="ts">export let size = "20";
const height = size;
</script>

<svg {height} style="fill: currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
	<path
		d="M10.907 22H5.435c-.604 0-1.092-.526-1.092-1.175v-7.058c-.604 0-1.093-.526-1.093-1.175v-2.358c0-.65.49-1.175 1.093-1.175h6.564zm8.75-12.942h-6.565V22h5.472c.604 0 1.093-.526 1.093-1.175v-7.058c.604 0 1.093-.526 1.093-1.175v-2.358c0-.65-.49-1.175-1.093-1.175M16.378 2C13.96 2 12 4.108 12 6.708h4.379c.604 0 1.093-.526 1.093-1.175V3.175c0-.65-.49-1.175-1.093-1.175M7.62 2c-.603 0-1.092.526-1.092 1.175v2.358c0 .65.49 1.175 1.092 1.175H12C12 4.108 10.039 2 7.62 2"
	/>
</svg>
